// extracted by mini-css-extract-plugin
export default {"container":"menu_container__Bb4eN","poweredBy":"menu_poweredBy__VGIH-"};